import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const ViewIcon = () => <FontAwesomeIcon icon={["fas", "eye"]}/>

export default ViewIcon;